import useMobile from "../hooks/useMobile";
import useTab from "../hooks/useTab";

const InfoSectionOne = (props) => {
  const { bannerData } = props;
  const mobile = useMobile();
  const tab = useTab();
  const iconClasses = [
    "ph-user-sound",
    "ph-book-open-text",
    "ph-math-operations",
    "ph-atom",
    "ph-globe",
    "ph-desktop-tower",
    "ph-paint-brush",
    "ph-microphone-stage",
    "ph-tree",
    "ph-hand-heart",
    "ph-desktop",
    "ph-cube-focus",
  ];
  return (
    <section className="info py-40 bg-main-600" id="banner">
      <div className="container">
        <div className="row gy-4">
          {bannerData?.map((banner, index) => (
            <div
              className={`col-xl-3 col-sm-6 ${
                mobile
                  ? index > 0 && "pt-4"
                  : tab
                    ? index > 1 && "pt-5"
                    : index > 3 && "pt-5"
              }`}
              data-aos="fade-up"
              data-aos-duration={200 + index * 200}
              key={index}
            >
              <div className="info-item animation-item flex-align gap-20">
                <span className="w-60 h-60 flex-center text-28 rounded-circle flex-shrink-0 bg-main-two-600 text-white">
                  <i
                    className={`animate__heartBeat ph ${
                      iconClasses[index % iconClasses.length]
                    }`}
                  />
                </span>
                <div className="flex-grow-1">
                  <h5 className="mb-8 text-white fw-medium">{banner?.title}</h5>
                  <span className="text-sm text-white">
                    {banner?.description}
                  </span>
                </div>
              </div>
            </div>
          ))}
          {/* <div
            className="col-xl-3 col-sm-6"
            data-aos="fade-up"
            data-aos-duration={400}
          >
            <div className="info-item animation-item flex-align gap-20">
              <span className="w-60 h-60 flex-center bg-white text-main-600 text-28 rounded-circle flex-shrink-0">
                <i className="animate__heartBeat ph-bold ph-users" />
              </span>
              <div className="flex-grow-1">
                <h5 className="mb-8 text-white fw-medium">
                  {bannerData[1]?.attributes?.Title}
                </h5>
                <span className="text-sm text-white">
                  {bannerData[1]?.attributes?.Description}
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-xl-3 col-sm-6"
            data-aos="fade-up"
            data-aos-duration={600}
          >
            <div className="info-item animation-item flex-align gap-20">
              <span className="w-60 h-60 flex-center bg-white text-main-600 text-28 rounded-circle flex-shrink-0">
                <i className="animate__heartBeat ph-bold ph-clock" />
              </span>
              <div className="flex-grow-1">
                <h5 className="mb-8 text-white fw-medium">
                  {bannerData[2]?.attributes?.Title}
                </h5>
                <span className="text-sm text-white">
                  {bannerData[2]?.attributes?.Description}
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-xl-3 col-sm-6"
            data-aos="fade-up"
            data-aos-duration={800}
          >
            <div className="info-item animation-item flex-align gap-20">
              <span className="w-60 h-60 flex-center bg-white text-main-600 text-28 rounded-circle flex-shrink-0">
                <i className="animate__heartBeat ph-bold ph-certificate" />
              </span>
              <div className="flex-grow-1">
                <h5 className="mb-8 text-white fw-medium">
                  {bannerData[3]?.attributes?.Title}
                </h5>
                <span className="text-sm text-white">
                  {bannerData[3]?.attributes?.Description}
                </span>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default InfoSectionOne;
